export default __webpack_public_path__ + "static/media/spicy.0b70602e.svg";